import dateFormat from "dateformat";
import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";
import { lerp, lerpInv } from "../../../../../shared/lib/html5-software-library/src/ranj/util/MathUtil";

export default class HudView extends AbstractView {

    constructor(target, languagePack, gameConfig) {
        super(target);
        this._languagePack = languagePack;
        this._gameConfig = gameConfig;
        this._status;
        this._progressBar = this._target.progressBar.bar;
        this._timeTextfield = this._target.timeTextfield;
        this._speedometer = this._target.speedometer;

        this._target.timeLabelTextfield.text = this.getText("hud.elapsedTime");
    }

    destroy() {
        super.destroy();
    }

    /**
     * @param {Number} value - Speed as used in game, NOT in range [0..1]!
     */
    setSpeed(value) {
        //Make speed of lanes correspond exactly to the ticks on the speedometer,
        //  (even though that is not linear)
        //Example: 1 > .25, 1.7 > .5, 2.7 > .75, 4 > 1
        //Find speed index below and above value, and interpolate
        const f = this._gameConfig.getValue("speedMultiplier");
        const speeds = this._gameConfig.getValue("speeds").map(s => s * f);
        const tick = 1 / speeds.length;
        let i0 = -1, i1;
        for (let i = 0; i < speeds.length; i++) {
            if (speeds[i] >= value) {
                i1 = i;
                break;
            } else {
                i0 = i;
            }
        }
        const s0 = i0 == -1 ? 0 : speeds[i0];
        const s1 = speeds[i1];
        const r = lerpInv(s0, s1, value);
        const speedMappedOnTicks = lerp(i0 * tick, i1 * tick, r) + tick;
        const tf = this._speedometer.totalFrames - 1;
        this._speedometer.gotoAndStop(Math.floor(tf * speedMappedOnTicks));
    }

    /**
     * @param {Number} value - in range [0..1]
     */
    setProgress(value) {
        value = Math.min(1, Math.max(0, value));
        const f = Math.floor(value * (this._progressBar.totalFrames - 1));
        this._progressBar.gotoAndStop(f);
    }

    /**
     * @param {Number} value - elapsed time in msecs
     */
    setTime(value) {
        this._timeTextfield.text = dateFormat(new Date(value), "MM:ss.L");
    }


}
